import React, { createContext, useContext, useState, useEffect } from 'react';
import { getCurrentUser } from '../lib/appwrite';

const GlobalContext = createContext();

export const useGlobalContext = () => {
    const context = useContext(GlobalContext);
    if (!context) {
        throw new Error('useGlobalContext must be used within a GlobalProvider');
    }
    return context;
};

export const GlobalProvider = ({ children }) => {
    const [isLogged, setIsLogged] = useState(false);
    const [user, setUser] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const checkUser = async () => {
            try {
                const currentUser = await getCurrentUser();
                if (currentUser) {
                    setIsLogged(true);
                    setUser(currentUser);
                } else {
                    setIsLogged(false);
                    setUser(null);
                }
            } catch (error) {
                console.error('Error checking user session:', error);
                setIsLogged(false);
                setUser(null);
            } finally {
                setIsLoading(false);
            }
        };

        checkUser();
    }, []);

    const value = {
        isLogged,
        setIsLogged,
        user,
        setUser,
        isLoading
    };

    if (isLoading) {
        return <div>Loading...</div>; // You can replace this with a proper loading component
    }

    return (
        <GlobalContext.Provider value={value}>
            {children}
        </GlobalContext.Provider>
    );
};